
define('ldsh!modules/integrations/services/api/template_api_not_enabled', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="pt0 pb0 text-center mt25 mb25 mr0 ml0">\n  <div class="empty_block">\n\n    <img alt="api" width="290" src="' +
__e( globalAssetsURL) +
'images/assets/deliveries-no-content.svg">\n    <div>\n      <h2 class="i18n mb16 md__page__title--medium text--secondary"\n        data-i18n="[html]INTEGRATIONS.API_TOKENS.NOT_ENABLED.LBL_TITLE"></h2>\n      <p class="i18n weight-500  mb16" data-i18n="INTEGRATIONS.API_TOKENS.NOT_ENABLED.LBL_DESCRIPTION"></p>\n      ';
 if(isAdmin){;
__p += '\n        <button id="upgradeProducts" class="btn--primary">\n          <span class="i18n" data-i18n="INTEGRATIONS.API_TOKENS.NOT_ENABLED.LBL_UPGRADE"></span>\n        </button>\n        ';
 };
__p += '\n    </div>\n  </div>\n</div>';

}
return __p
};});

